@if (value !== null && value !== undefined && value !== '') {
  <rxap-copy-to-clipboard
    [value]="value"
    class="copy-to-clipboard">
  </rxap-copy-to-clipboard>
}
<ng-content></ng-content>
